const state = {
  capturedImage: []
}

const mutations = {
  setCapturedImage(state, image) {
    state.capturedImage.push(image)
  },
  clearCapturedImage(state) {
    state.capturedImage.length = 0;
  }
}

const getters = {
  capturedImage: state => state.capturedImage
}

export default {
  state,
  mutations,
  getters
}
